export const keys: Breakpoint[] = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'];
export const values: BreakpointValues = {
  xxs: 0,
  xs: 375,
  sm: 768,
  md: 1024,
  lg: 1440,
  xl: 1596,
};

export type Breakpoint = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type BreakpointValues = { [key in Breakpoint]: number };

export interface IBreakpoints {
  keys: Breakpoint[];
  values: BreakpointValues;
  up: (key: Breakpoint) => string;
  down: (key: Breakpoint) => string;
  width: (key: Breakpoint) => number;
}

const createBreakpoints = () => {
  const unit = 'px';

  const up = (key: Breakpoint) => `@media (min-width:${values[key]}${unit})`;

  const down = (key: Breakpoint) => {
    const endIndex = keys.indexOf(key) + 1;
    if (endIndex === keys.length) {
      return up('xxs');
    }
    return `@media (max-width:${values[key]}${unit})`;
  };

  const width = (key: Breakpoint) => values[key];

  return {
    keys,
    values,
    up,
    down,
    width,
  };
};

export const breakpoints = createBreakpoints();
